<template>
  <v-container fluid class="pa-0 col-12 justify-center">
    <!--TOOLBAR-->
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("ebay_categories") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-app-bar>
    <div v-if="loading" class="col-12 mt-12 text-center mt-5 justify-center">
      <v-progress-circular color="#D32F2F" indeterminate size="100" />
    </div>
    <div v-else class="pa-2">
      <div>
        <v-col xs="12" sm="12">
          <div>
            <v-alert
              :value="true"
              type="error"
              border="bottom"
              class="mt-3"
              variant="outlined"
              text
            >
              {{ $t("ebay_search_category") }}
            </v-alert>
          </div>
        </v-col>
      </div>
      <v-data-table
        :headers="headers"
        :items="categories"
        hide-default-footer
        :items-per-page="-1"
        class="elevation-1 nowrap-headers"
        item-key="_id"
      >
        <template #item="{ item, index }">
          <tr
            :class="{ tableRowColorSelected: index === activeRow }"
            class="tableRowColor"
            @click="activeRow = index"
          >
            <td>{{ item.Leaf ? "✅" : "❌" }}</td>
            <td v-html="highlightMatch(item.CategoryId)" />
            <td v-html="highlightMatch(item.Level)" />
            <td v-html="highlightMatch(item.Compatibility)" />
            <td v-html="highlightMatch(item.Breadcrumb)" />
            <td class="cell-style" v-html="highlightMatch(item.L1)" />
            <td class="cell-style" v-html="highlightMatch(item.L2)" />
            <td class="cell-style" v-html="highlightMatch(item.L3)" />
            <td class="cell-style" v-html="highlightMatch(item.L4)" />
            <td class="cell-style" v-html="highlightMatch(item.L5)" />
            <td class="cell-style" v-html="highlightMatch(item.L6)" />
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-btn
      v-show="showScrollTop"
      icon
      class="scroll-top-btn"
      color="#F44336"
      @click="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import getRequest from "../api/getRequest";

export default {
  data: () => ({
    loading: false,
    categories: [],
    headers: [
      { title: "Leaf", value: "Leaf", sortable: true },
      { title: "Category ID", value: "CategoryId", sortable: true },
      { title: "Level", value: "Level", sortable: true },
      { title: "Compatibility", value: "Compatibility", sortable: false },
      { title: "Breadcrumb", value: "Breadcrumb", sortable: false },
      { title: "L1", value: "L1", sortable: false },
      { title: "L2", value: "L2", sortable: false },
      { title: "L3", value: "L3", sortable: false },
      { title: "L4", value: "L4", sortable: false },
      { title: "L5", value: "L5", sortable: false },
      { title: "L6", value: "L6", sortable: false },
    ],
    searchTerm: "",
    activeRow: null,
    showScrollTop: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getEbayCategories();
  },
  methods: {
    getEbayCategories() {
      this.loading = true;
      getRequest("/list-ebay-categories/")
        .then((response) => {
          if (response && response.ebayCategories) {
            this.categories = response.ebayCategories;
          } else {
            this.categories = [];
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    highlightMatch(text) {
      if (!this.searchTerm) return text;
      const term = this.searchTerm.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&"); // escape regex chars
      const regex = new RegExp(`(${term})`, "gi");
      return String(text).replace(regex, "<mark>$1</mark>");
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300; // show button after scrolling down 300px
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
<style scoped>
.text-start {
  text-align: start !important;
}
.cell-style {
  max-width: 100px !important;
}
.breadcrumb-cell {
  max-width: 150px !important;
}
.highlight {
  background-color: yellow !important;
}
.scroll-top-btn {
  position: fixed;
  bottom: 45px;
  right: 15px;
  z-index: 9999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
</style>
